import { sleep } from '@ankr.com/common';
import { IUsageDataMRPCResponse } from 'multirpc-sdk';

import statsMockData from './stats.json';

export async function fetchStatisticsMock(): Promise<IUsageDataMRPCResponse> {
  await sleep(1000);

  return statsMockData as IUsageDataMRPCResponse;
}
